import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs: {
    question: string;
    answer: ReactNode;
  }[] = [{
    question: '¿Cuánto tiempo tarda en llegar?',
    answer: 'Entregamos en 5-7 días hábiles a cualquier estado de USA. Recibirás número de tracking por email.'
  }, {
    question: '¿Son seguros? ¿Tienen efectos secundarios?',
    answer: 'Todos nuestros productos son 100% naturales, sin estimulantes ni químicos. Son seguros para uso diario. Consulta tu médico si estás embarazada o bajo tratamiento médico.'
  }, {
    question: '¿Cómo y cuándo los tomo?',
    answer: 'Cada producto viene con instrucciones. En general se toman en la mañana mezclados con agua. El video de arriba te explica exactamente cómo prepararlos.'
  }, {
    question: '¿Por qué el paquete del medio es el más recomendado?',
    answer: 'El Gut Rest Program combina los 3 productos esenciales para digestión, limpieza y detox hepático trabajando en sinergia. Es el balance perfecto entre resultado y precio.'
  }, {
    question: '¿Puedo tomar estos productos si tengo condiciones médicas?',
    answer: 'Son productos naturales de consumo general. Sin embargo, si tienes condiciones médicas específicas, recomendamos consultar con tu médico antes de comenzar.'
  }, {
    question: '¿Tienen envío gratis?',
    answer: 'Sí. Los paquetes Gut Rest Program ($141) y Advanced Recovery System ($189.50) incluyen envío gratis. El Starter Kit tiene $12 de envío adicional.'
  }, {
    question: '¿Cómo funciona la garantía?',
    answer: <div className="space-y-4" data-id="element-26">
          <p data-id="element-27">Queremos que compres con tranquilidad.</p>
          <p data-id="element-28">Podés acceder a la garantía si:</p>
          <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-29">
            <li data-id="element-30">Recibiste el producto en mal estado</li>
            <li data-id="element-31">Tu pedido demoró más de 10 días hábiles en llegar</li>
            <li data-id="element-32">
              Tomaste el producto correctamente y sentís que no era para vos
            </li>
          </ul>
          <p data-id="element-33">En ese caso podés escribirnos detallando el motivo.</p>
          <p data-id="element-34">
            Nuestro equipo evaluará cada situación de manera individual y, si el
            motivo es considerado válido dentro de nuestras políticas, podremos
            realizar el reembolso total del dinero abonado.
          </p>
          <p data-id="element-35">
            Esta política existe para proteger al cliente genuino y asegurar una
            experiencia seria para todos.
          </p>
        </div>
  }];
  return <section id="faq" className="py-24 bg-white" data-id="element-36">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="text-center mb-16" data-id="element-38">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-[#1A1A1A]" data-id="element-39">
            Preguntas Frecuentes
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-40">
          {faqs.map((faq, index) => <div key={index} className="bg-[#FAFAF7] rounded-2xl border border-gray-100 overflow-hidden" data-id="element-41">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-6 text-left flex justify-between items-center focus:outline-none" data-id="element-42">
                <span className="font-bold text-[#1A1A1A] text-lg pr-4" data-id="element-43">
                  {faq.question}
                </span>
                <ChevronDown className={`text-[#1B5E20] transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-44" />
              </button>

              <AnimatePresence data-id="element-45">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-46">
                    <div className="px-6 pb-6 text-gray-600 text-lg leading-relaxed border-t border-gray-100 pt-4" data-id="element-47">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}